import Swal from 'sweetalert2';

const SuccessToast = Swal.mixin({
  showConfirmButton: false,
  position: 'bottom-end',
  toast: true,
  icon: 'success',
  timer: 2500
});

const toast = (swalOptions = {}) => SuccessToast.fire({ ...swalOptions });

export default toast;
